export const discountInclude = "entities.entity,entities,roles,payment_method,availability,tip,conditions";
